// Security Center (Batch 1) API client. axiosClient.baseURL = "/api/v1".
import api from './axiosClient';

const clean = (o = {}) =>
  Object.fromEntries(Object.entries(o).filter(([, v]) => v !== '' && v !== null && v !== undefined));

// ── Overview / live ───────────────────────────────────────────────
export const getOverview = async (siteId, days = 7) =>
  (await api.get('/security/overview', { params: clean({ siteId, days }) })).data;

export const getLive = async (siteId, sinceMs) =>
  (await api.get('/security/live', { params: clean({ siteId, sinceMs }) })).data;

// ── Threats ───────────────────────────────────────────────────────
export const listThreats = async (query) =>
  (await api.get('/security/threats', { params: clean(query) })).data;

export const getThreat = async (id) => (await api.get(`/security/threats/${id}`)).data;
export const resolveThreat = async (id) => (await api.post(`/security/threats/${id}/resolve`)).data;
export const markFalsePositive = async (id, allowlistIp = false) =>
  (await api.post(`/security/threats/${id}/false-positive`, { allowlistIp })).data;
export const blockThreatIp = async (id, expiresInMinutes) =>
  (await api.post(`/security/threats/${id}/block`, null, { params: clean({ expiresInMinutes }) })).data;

/** Downloads the CSV through axios so the Authorization header is sent. */
export async function exportThreatsCsv(query) {
  const res = await api.get('/security/threats/export', {
    params: clean(query),
    responseType: 'blob',
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `threats-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// ── Traffic rules ─────────────────────────────────────────────────
export const listRules = async (query) =>
  (await api.get('/security/rules', { params: clean(query) })).data;
export const createRule = async (body) => (await api.post('/security/rules', body)).data;
export const bulkCreateRules = async (body) => (await api.post('/security/rules/bulk', body)).data;
export const deleteRule = async (id) => (await api.delete(`/security/rules/${id}`)).data;

// ── Protection settings ───────────────────────────────────────────
export const getProtectionSettings = async (siteId) =>
  (await api.get('/security/settings', { params: { siteId } })).data;
export const saveProtectionSettings = async (siteId, body) =>
  (await api.put('/security/settings', body, { params: { siteId } })).data;

// ── Analytics ─────────────────────────────────────────────────────
export const getTimeseries = async (siteId, days = 14) =>
  (await api.get('/analytics/timeseries', { params: clean({ siteId, days }) })).data;
export const getTechnology = async (siteId, days = 14) =>
  (await api.get('/analytics/technology', { params: clean({ siteId, days }) })).data;
export const getHeatmap = async (siteId, days = 14) =>
  (await api.get('/analytics/heatmap', { params: clean({ siteId, days }) })).data;
export const getEngagement = async (siteId, days = 14) =>
  (await api.get('/analytics/engagement', { params: clean({ siteId, days }) })).data;

export function errorMessage(err) {
  const d = err?.response?.data;
  return d?.message || d?.detail || d?.title || err?.message || 'Something went wrong.';
}
